export default __webpack_public_path__ + "static/media/nft_games.637131cd.png";